/* global window */

import Cookies from 'js-cookie';
import { Route } from 'react-router-dom';

const CheckoutRoute = ({ component: Component, ...rest }) => {
  const redirectToAvailability = () => {
    window.location.href = '/reservation/availability';
    return null;
  };
  return (
    <Route
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      render={(props) =>
        Cookies.get('reservationCartId') ? (
          // eslint-disable-next-line react/jsx-props-no-spreading
          <Component {...props} />
        ) : (
          redirectToAvailability()
        )
      }
    />
  );
};

export default CheckoutRoute;
